<ng-template #content let-modal>
   <div role="dialog">
      <div class="scrim">
         <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <button
                     class="br-button close circle"
                     type="button"
                     (click)="modal.dismiss('Fechar')"
                     data-dismiss="modal"
                     aria-label="Fechar"
                  >
                     <i class="fas fa-times" aria-hidden="true"></i>
                  </button>
               </div>
               <div class="modal-body">
                  {{ citacao }}
                  <a href="{{ linkSite }}">{{ linkSite }}</a
                  >. Acesso em: {{ data }}.
               </div>
               <div class="modal-footer">
                  <button
                     class="br-button secondary mr-3"
                     type="button"
                     (click)="copiarTexto()"
                     [class.active]="isActive"
                  >
                     {{ !isActive ? 'Copiar' : 'Copiado' }}
                  </button>
                  <button
                     class="br-button primary mr-3"
                     type="button"
                     data-dismiss="modal"
                     (click)="modal.close('Fechar')"
                  >
                     Fechar
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</ng-template>
